import React from "react";
import PropTypes from "prop-types";

const NumberCellNegative = ({ value, getValue, threshold }) => (
  <div
    style={{
      width: "100%",
      textAlign: "right",
      color: value >= threshold ? "inherit" : "red"
    }}
  >
    {getValue(value)}
  </div>
);

NumberCellNegative.propTypes = {
  value: PropTypes.number,
  getValue: PropTypes.func,
  threshold: PropTypes.number
};

NumberCellNegative.defaultProps = {
  getValue: (val) => val,
  threshold: 0
};

export default NumberCellNegative;
